(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization-type', {
            parent: 'entity',
            url: '/hospitalization-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalizationType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-types.html',
                    controller: 'HospitalizationTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hospitalization-type-detail', {
            parent: 'entity',
            url: '/hospitalization-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.hospitalizationType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-detail.html',
                    controller: 'HospitalizationTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HospitalizationType', function($stateParams, HospitalizationType) {
                    return HospitalizationType.get({id : $stateParams.id});
                }]
            }
        })
        .state('hospitalization-type.new', {
            parent: 'hospitalization-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-dialog.html',
                    controller: 'HospitalizationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type', null, { reload: true });
                }, function() {
                    $state.go('hospitalization-type');
                });
            }]
        })
        .state('hospitalization-type.edit', {
            parent: 'hospitalization-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-dialog.html',
                    controller: 'HospitalizationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationType', function(HospitalizationType) {
                            return HospitalizationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-type.delete', {
            parent: 'hospitalization-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type/hospitalization-type-delete-dialog.html',
                    controller: 'HospitalizationTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HospitalizationType', function(HospitalizationType) {
                            return HospitalizationType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
